// Lightweight analytics helper. Pushes to GA4 dataLayer/gtag and Microsoft Clarity.
// IDs are placeholders configured in public/index.html — events still queue safely.

export const track = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
    if (typeof window.gtag === "function") {
      window.gtag("event", event, params);
    }
    if (typeof window.clarity === "function") {
      window.clarity("event", event);
    }
    // eslint-disable-next-line no-console
    console.debug("[analytics]", event, params);
  } catch (e) {
    /* no-op */
  }
};

export const EVENTS = {
  BOOKING_STARTED: "booking_started",
  WALKTHROUGH_BOOKED: "walkthrough_booked",
  QUOTE_SUBMITTED: "quote_submitted",
  CALL_CLICK: "call_click",
  INSTAGRAM_CLICK: "instagram_click",
  PRICING_VIEW: "pricing_view",
};
